import { atom } from "jotai";

export const profileTabsOverrideIndex = atom(0);
export const isLoadingBackground = atom(false);
export const snackbarMessage = atom({
  open: false,
  message: "",
  alertType: "",
});
